/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerComponents } from "../../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import PlayIcon from "../../../../../../shared/icons/player/Play.svg";
import { MediaImageType } from "../../../../../../shared/types/enums";
import { getImageByType } from "../../../../../../shared/utils/image";
import { usePlayerCurrentMedia } from "../../../../../Controller";
import { useCustomPlayerContext } from "../../../../../CustomPlayerContext";
import {
  DropdownHeader,
  DropdownMenuItemExpandable,
  DropdownMenuSection,
  DropdownScrollableArea,
} from "../../../../Base";

import { useSeason } from "./useSeason";

import "./SeasonsSection.scss";

const spinnerStyle = { margin: "15px" };
const spinnerSize = 50;

export const SeasonsSection = () => {
  const { seasonMedia, seriesMedia } = useSeason();
  const { media } = usePlayerCurrentMedia();
  const { Button, LoaderSpinner } = usePlayerComponents();
  const { t } = usePlayerTranslation();
  const { onNavigateToMedia } = useCustomPlayerContext();

  return (
    <DropdownMenuSection name="season">
      <DropdownHeader navigateToSection="seasons">
        {seriesMedia.Media?.Title}
      </DropdownHeader>
      {seasonMedia.IsLoading ? (
        <LoaderSpinner
          width={spinnerSize}
          height={spinnerSize}
          style={spinnerStyle}
        />
      ) : (
        <DropdownScrollableArea>
          {seasonMedia.Media?.Media?.map((episode) => {
            const imageData = getImageByType(
              episode?.Images || [],
              MediaImageType.Frame,
            );
            return (
              <DropdownMenuItemExpandable
                key={episode.Id}
                title={episode.Title}
                orderInParent={episode.OrderInParent}
              >
                <div className="SeasonsSection__Content">
                  <div className="SeasonsSection__Content__Thumbnail">
                    {imageData?.Url && (
                      <img
                        src={imageData.Url}
                        alt={episode.Title || ""}
                        className="SeasonsSection__image"
                      />
                    )}
                    {media.Id !== episode.Id && (
                      <div className="SeasonsSection__Content__Thumbnail__Control">
                        <Button
                          variant="secondary"
                          onClick={() => onNavigateToMedia?.(episode)}
                          aria-label={
                            episode.Title
                              ? `${t("PLAYER_TOOLTIP_PLAY")} ${episode.Title}`
                              : t("PLAYER_TOOLTIP_PLAY")
                          }
                          iconOnly
                        >
                          <PlayIcon aria-hidden="true" focusable="false" />
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className="SeasonsSection__Content__Metadata">
                    <div
                      className="SeasonsSection__Content__Metadata__Description"
                      dangerouslySetInnerHTML={{
                        __html: episode.ShortDescription || "",
                      }}
                    />
                  </div>
                </div>
              </DropdownMenuItemExpandable>
            );
          })}
        </DropdownScrollableArea>
      )}
    </DropdownMenuSection>
  );
};
